import { Typography } from 'fronton-react';
import { useState } from 'react';
import { getLinkPathToCollections } from 'common/helpers/get-link-path-to-collections.helper';
import { useAppSelector } from 'common/hooks';
import { dataFromParentMicrofrontSlice } from 'store/data-from-parent-microfront-slice';
import { projectsSlice } from 'app-entities/projects/projects-slice';
import { ImageFallbackIcon } from '../image-fallback-icon/image-fallback-icon';
import {
  card,
  card__caption,
  card__collection__title,
  card__image__container,
  card__image__grid,
  card__grid__image,
  card__grid__fallback,
} from './styles';

const MAX_IMAGES_COUNT = 4;

export const CollectionCard = ({ type }: { type: string }) => {
  const [failedImages, setFailedImages] = useState<Record<string, boolean>>({});
  const isShowTitle = useAppSelector(dataFromParentMicrofrontSlice.selectors.selectIsShowProjectName);
  const projects = useAppSelector(projectsSlice.selectors.selectProjects);

  const handleImageError = (id: string) => {
    setFailedImages(prev => ({
      ...prev,
      [id]: true,
    }));
  };

  return (
    <a
      data-testid="collection-card"
      target="_blank"
      className={card}
      href={`${getLinkPathToCollections(type)}`}
      rel="noreferrer">
      <div className={card__image__container}>
        <div className={card__image__grid}>
          {projects.slice(0, MAX_IMAGES_COUNT).map(project => {
            const {
              projectLibraryId,
              mainPictureLink,
              projectLibraryName,
              projectTransliteration,
              mainPictureLinkInWebPFormat,
            } = project;
            const isFailedImage = failedImages[projectLibraryId];

            return isFailedImage ? (
              <div key={project.projectLibraryId} className={card__grid__fallback}>
                <ImageFallbackIcon />
              </div>
            ) : (
              <picture key={projectLibraryId}>
                <source type="image/webp" srcSet={mainPictureLinkInWebPFormat} />
                <img
                  src={mainPictureLink}
                  alt={projectLibraryName ?? projectTransliteration}
                  className={card__grid__image}
                  onError={() => handleImageError(projectLibraryId)}
                />
              </picture>
            );
          })}
        </div>
      </div>

      <div className={card__caption}>
        {isShowTitle && (
          <Typography
            color="text-primary"
            data-testid="inspiration-gallery-all-collections"
            className={card__collection__title}
            variant="s"
            size="body_long">
            Все коллекции
          </Typography>
        )}
      </div>
    </a>
  );
};
